import React,{useState,useEffect} from 'react'
import { KTSVG } from '../../helpers/KTSVG'
import {Tooltip} from 'react-tooltip'
import {useForm} from 'react-hook-form'
import {toast} from 'react-toastify'
import mediaService from '../../../services/media.service'
import TimeDifference from '../../common/TimeDifference'

function FileCard({item,refreshList}) {
    const [isEditing,setIsEditing] = useState(false)
    const [isDeleting,setIsDeleting] = useState(false)

    const {register,handleSubmit,formState:{errors}} = useForm({
        defaultValues:{
            resourceId : item.id,
            resourceName : item.name
        }
    })
    /**
     *   
        "id": 33,
        "name": "ckod-eblast-december2023.jpg",
        "path": "https://eyeconx.s3.us-east-2.amazonaws.com/eyesonsheppard/assets/514f52977bbd44ef8bef2c905fabf3a5.jpg",
        "thumbnailPath": "https://eyeconx.s3.us-east-2.amazonaws.com/eyesonsheppard/assets/thumbnail/514f52977bbd44ef8bef2c905fabf3a5.jpg",
        "type": "image/jpeg",
        "size": "407.50 KB",
        "sizeBytes": 417280,
        "clinicId": 5,
        "createdAt": "2023-12-14T14:51:07",
        "modified_at": null
     * 
     */

        const handleDownload = () => {
            // Create a temporary anchor element
            window.open(item.path, '_blank');
          
        }
    const toogleEdit = ()=>{
        setIsEditing(!isEditing)
    }

    const onSubmit = (data)=>{
        console.log(data)
        mediaService.renameMedia(item.clinicId,data)
        .then(res=>{
            toast.success("Media Renamed")
            refreshList()
        })
        .catch(err=>{
            toast.error("Error updating Media name")
        })
        

    }
    const handleDelete = ()=>{
        const itemArray = [item.id]
        mediaService.deleteMedia(item.clinicId,itemArray)
        .then(res=>{
            toast.success("Media Deleted")
           refreshList()
        })
        .catch(error=>{
          console.log(error)
            toast.error("Error while Delete")
        })

    }
    const toogleDelete = ()=>{
        setIsDeleting(!isDeleting)
    }
    const handleCopy = async ()=>{
        const textToCopy = item.path
        try {
          await navigator.clipboard.writeText(textToCopy);
          toast.success("Copied")
        } catch (error) {
          console.error('Failed to copy using navigator.clipboard:', error);
          // Fallback: use textarea and document.execCommand('copy')
          const textArea = document.createElement('textarea');
          textArea.value = textToCopy;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          toast.success("Copied")
        }
       
      }
  return (
    <div className="col-md-6 col-lg-4 col-xl-3 mb-4">
        <div className="card h-100 bg-body-secondary">
                <button
                    data-tooltip-id={"tt_options_"+item.id}
                    data-tooltip-place="bottom-start"
                    className="position-absolute btn"
                    style={{ top: '0', right: '0', margin: '5px' }}
                >
                    <KTSVG
                    path="media/icons/duotune/general/gen053.svg"
                    className="svg-icon-1 "
                    />
                </button>
                <Tooltip id={"tt_options_"+item.id}
                 clickable
                 className="bg-info-subtle"
                 style={{ zIndex: "107" }}
                >
                <div className="d-flex flex-column mt-3">
                            <button className="btn btn-sm btn-primary mb-3"
                               data-tooltip-id="tt_download"
                               data-tooltip-content="Download"
                               data-tooltip-place='bottom'
                               onClick = {handleDownload}
                            >
                                <KTSVG path="media/icons/duotune/files/fil017.svg" className='svg-icon-1'/>
                            </button>
                            <button 
                                 data-tooltip-id="tt_download"
                                 data-tooltip-content="Edit Name"
                                 data-tooltip-place='bottom'
                                 className="btn btn-sm btn-warning mb-3"
                                 onClick={toogleEdit}
                                 >
                                <KTSVG path="media/icons/duotune/general/gen055.svg" className='svg-icon-1'/>
                            </button>
                            <button 
                                className="btn btn-sm  btn-danger mb-3"
                                data-tooltip-id="tt_download"
                                data-tooltip-content="Delete"
                                data-tooltip-place='bottom'
                                onClick={toogleDelete}
                                >
                                <KTSVG path="media/icons/duotune/general/gen027.svg" className='svg-icon-1'/>
                            </button>
                            <button 
                                className="btn btn-sm btn-success mb-3"
                                data-tooltip-id="tt_download"
                                data-tooltip-content="Copy to Clipboard"
                                data-tooltip-place='bottom'
                                onClick={handleCopy}
                                >
                                <KTSVG path="media/icons/duotune/communication/com008.svg" className='svg-icon-1'/>
                            </button>
                            <Tooltip id="tt_download"/>
                        </div>
                </Tooltip>
            <div className="card-body">

                <div className="d-flex flex-column align-items-center justify-content-center">
                     
                     <img src={item.thumbnailPath} alt="item" style={{ width: "150px",
    height: "100px",
    objectFit: "contain"}}/>
                    
                     {isEditing?<>
                        <form onSubmit={handleSubmit(onSubmit)} className=''>
                            <div className="row align-items-center g-3 mt-2 mb-2">
                            <div className="col-8">
                                    <input 
                                        type="text" 
                                        {...register("resourceName",{required:true})} 
                                        className="form-control form-control-sm" />
                                </div>
                                <div className="col-4">
                                    <button type="submit" className="btn btn-sm btn-light-primary">Save</button>
                                </div>
                                </div>
                        </form>
                       
                     </>:
                     <span className="text-gray-800 fw-bold mt-4 mb-2">
                        {item.name}
                    </span> 
                     }
                           {isDeleting?<>
                                <div className="d-flex flex-column justify-content-center bg-secondary m-1 p-4 rounded">
                                    <span className="text-gray-800">Permanently Delete?</span>
                                    <div className="d-flex justify-content-between mt-2">
                                            <button className="btn btn-danger btn-sm me-2" onClick={handleDelete}>Delete</button>
                                            <button className="btn btn-info btn-sm" onClick={toogleDelete}>Cancel</button>
                                        </div>
                                </div>
                                
                           </>:""}
                </div>
                <div className="d-flex justify-content-between alignt-items-center">
                                        <span className="fs-7 fw-semibold text-gray-500">
                                            {item.size}
                                </span>
                                <span className="fs-7 fw-semibold text-gray-500">
                                            <TimeDifference dateString={item.createdAt}/>
                                </span>
                            </div>
                
            </div>
        </div>
    </div>
  )
}

export default FileCard